import React from 'react';
import { Button, Form, Alert } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { TextField } from "../common/FormComponents";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentAlt, faSpinner } from '@fortawesome/free-solid-svg-icons';
import {hasGroup} from "../common/permissions";

const validate = values => {
    const errors = {};
    if (!values.reason) {
        errors.reason = '* Required';
    } else if (values.reason.length < 4) {
        errors.username = '* Must be more than 4 characters';
    }
    return errors;
};

const RecruitmentApplicationForm = props => {
    const { handleSubmit } = props;

    const escalateButton = (state) => {
        switch(state) {
            case "step_1_submitted":
            case "step_1_redo_submitted":
            case "step_2_submitted":
            case "step_2_redo_submitted":
                return (
                    <Button
                        type="submit"
                        onClick={handleSubmit(values =>
                            props.onSubmit({
                                ...values,
                                button: 'escalate'
                        }))}
                        disabled={props.pristine || props.pending}>
                        {(props.pending) ? (
                        <FontAwesomeIcon className="text-primary" icon={faSpinner} spin fixedWidth />
                        ) : ('')}
                        Escalate
                    </Button>
                );
            default:
                return null
        }
    };

    const rejectButton = (state) => {
        switch(state) {
            case "step_1_submitted":
            case "step_1_redo_submitted":
            case "step_2_submitted":
            case "step_2_redo_submitted":
            case "step_3_interview":
                return (
                    <Button
                        type="submit"
                        onClick={handleSubmit(values =>
                            props.onSubmit({
                                ...values,
                                button: 'reject'
                        }))}
                        disabled={props.pristine || props.pending}>
                        {(props.pending) ? (
                        <FontAwesomeIcon className="text-primary" icon={faSpinner} spin fixedWidth />
                        ) : ('')}
                        Reject
                    </Button>
                );
            default:
                return null
        }
    };

    const closeButton = (state) => {
        switch(state) {
            case "step_1_redo":
            case "step_1_approved":
            case "step_1_redo_approved":
            case "step_3_interview":
                return (
                    <Button
                        type="submit"
                        onClick={handleSubmit(values =>
                            props.onSubmit({
                                ...values,
                                button: 'close'
                        }))}
                        disabled={props.pristine || props.pending}>
                        {(props.pending) ? (
                        <FontAwesomeIcon className="text-primary" icon={faSpinner} spin fixedWidth />
                        ) : ('')}
                        Close
                    </Button>
                );
            default:
                return null
        }
    };

    const redoButton = (state) => {
        switch(state) {
            case "step_1_submitted":
            case "step_2_submitted":
                return (
                    <Button
                        type="submit"
                        onClick={handleSubmit(values =>
                            props.onSubmit({
                                ...values,
                                button: 'redo'
                        }))}
                        disabled={props.pristine || props.pending}>
                        {(props.pending) ? (
                        <FontAwesomeIcon className="text-primary" icon={faSpinner} spin fixedWidth />
                        ) : ('')}
                        Redo
                    </Button>
                );
            default:
                return null
        }
    };

    const acceptButton = (state) => {
        switch(state) {
            case "step_3_interview":
                return (
                    <Button
                        type="submit"
                        onClick={handleSubmit(values =>
                            props.onSubmit({
                                ...values,
                                button: 'accept'
                        }))}
                        disabled={props.pristine || props.pending}>
                        {(props.pending) ? (
                        <FontAwesomeIcon className="text-primary" icon={faSpinner} spin fixedWidth />
                        ) : ('')}
                        Accept
                    </Button>
                );
            default:
                return null
        }
    };
    return (
        <Form>
            <div className="adt-flex-container">
                <div className="adt-flex-icon">
                    <FontAwesomeIcon className="text-primary" size="lg" icon={faCommentAlt} fixedWidth/>
                </div>
                <div className="adt-flex-item">
                    <Field component={TextField}
                           name="reason"
                           type="text"
                           label="Reason"
                           fullWidth
                           multiline
                           onChange={this.handleChange}
                           helperText="Press enter for more lines."
                    />
                </div>
                <div className="adt-flex-item-small">
                    {redoButton(props.state)}
                </div>
                <div className="adt-flex-item-small">
                    {escalateButton(props.state)}
                </div>
                <div className="adt-flex-item-small">
                    {rejectButton(props.state)}
                </div>
                <div className="adt-flex-item-small">
                    {closeButton(props.state)}
                </div>
                { hasGroup('Interviewer', props.auth.groups) ?
                    (
                    <div className="adt-flex-item-small">
                        {acceptButton(props.state)}
                    </div>
                    ): ('')
                }
            </div>

            {props.errors ? (
                <Alert bsStyle="danger">Really?</Alert>
            ) : ('')
            }
        </Form>
    )
};

export default reduxForm({ form: 'recruitmentApplication', validate })(RecruitmentApplicationForm)


// WEBPACK FOOTER //
// ./src/Recruitment/RecruitmentApplicationForm.js